<template>
  <div class="container text-center py-4">
    <h2>Usluge</h2>
    <div class="text-justify">
      <c-card v-for="(x, idx) in services" :key="idx"
        :img="`services/${x.img}`"
        :title="x.title"
        :desc="x.desc"
      />
    </div>
  </div>
</template>

<script>
import cCard from "../components/cCard.vue";
export default {
  metaInfo: {
    titleTemplate: "%s | Usluge",
    meta: [
      {
        name: "description",
        content: "IG PROG pruža usluge izrade i održavanja web stranica, aplikacija i računalnih programa.",
      },
    ],
  },
  components: {
    cCard,
  },
  data() {
    return {
      services: [
        { img: 'webapplication.png', title: 'Web aplikacije', desc: 'Izrada web aplikacija prema Vašim specifičnim potrebama korištenjem najnovijih tehnologija.' },
        { img: 'webpage.png', title: 'Web stranice', desc: 'Izrada moderno dizajniranih i responzivnih web stranica za obrte, tvrtke, apartmane, udruge i sl.' },
        { img: 'software.png', title: 'Računalni programi', desc: 'Izrada računalnih programa koji se instaliraju i izvršavaju unutar vašeg operativnog sustava.' },
        { img: 'seo.jpg', title: 'SEO optimizacija', desc: 'Optimizacija novih ili postojećih web stranica sa ciljem boljeg prikazvanja na pretraživačkim mrežama.' },
        { img: 'adwords.jpg', title: 'Adwords kampanja', desc: 'Vođenje Google Ads kampanje u cilju povećanja broja posjeta na Vašu web stranicu.' }
      ],
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/services.vue